export type SubmitResult = {
    ok: boolean
    message?: string
    errors?: Record<string, string>
}

/** Posts JSON to one of the site's own API routes and normalizes the answer. */
export const postJson = async (url: string, body: unknown): Promise<SubmitResult> => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        })

        const payload = await response.json().catch(() => ({})) as { ok?: boolean, message?: string, errors?: Record<string, string> }

        if (response.ok && payload.ok) return { ok: true }

        return {
            ok: false,
            message: payload.message ?? 'Something went wrong. Please try again.',
            errors: payload.errors
        }
    }
    catch {
        return { ok: false, message: 'We could not reach the server. Check your connection and try again.' }
    }
}

export const focusFirstError = (prefix: string, fields: Array<string>): void => {
    const first = fields[0]

    if (!first) return

    window.requestAnimationFrame(() => {
        document.getElementById(`${prefix}-${first}`)?.focus()
    })
}
